var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFixedPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#FDF2ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 9.98828C5.60833 9.98828 5.4895 9.94045 5.3935 9.84478C5.29783 9.74878 5.25 9.62995 5.25 9.48828H4.5C4.35833 9.48828 4.2395 9.44045 4.1435 9.34478C4.04783 9.24878 4 9.12995 4 8.98828C4 8.84661 4.04783 8.72778 4.1435 8.63178C4.2395 8.53611 4.35833 8.48828 4.5 8.48828H6.5V7.48828H4.5C4.35833 7.48828 4.2395 7.44045 4.1435 7.34478C4.04783 7.24878 4 7.12995 4 6.98828V4.98828C4 4.84661 4.04783 4.72778 4.1435 4.63178C4.2395 4.53611 4.35833 4.48828 4.5 4.48828H5.25C5.25 4.34661 5.29783 4.22778 5.3935 4.13178C5.4895 4.03611 5.60833 3.98828 5.75 3.98828C5.89167 3.98828 6.0105 4.03611 6.1065 4.13178C6.20217 4.22778 6.25 4.34661 6.25 4.48828H7C7.14167 4.48828 7.2605 4.53611 7.3565 4.63178C7.45217 4.72778 7.5 4.84661 7.5 4.98828C7.5 5.12995 7.45217 5.24861 7.3565 5.34428C7.2605 5.44028 7.14167 5.48828 7 5.48828H5V6.48828H7C7.14167 6.48828 7.2605 6.53611 7.3565 6.63178C7.45217 6.72778 7.5 6.84661 7.5 6.98828V8.98828C7.5 9.12995 7.45217 9.24878 7.3565 9.34478C7.2605 9.44045 7.14167 9.48828 7 9.48828H6.25C6.25 9.62995 6.20217 9.74878 6.1065 9.84478C6.0105 9.94045 5.89167 9.98828 5.75 9.98828ZM8.975 12.7758C8.90833 12.7758 8.84583 12.7654 8.7875 12.7448C8.72917 12.7238 8.675 12.6883 8.625 12.6383L7.2 11.2133C7.10833 11.1216 7.0625 11.0049 7.0625 10.8633C7.0625 10.7216 7.10833 10.6049 7.2 10.5133C7.29167 10.4216 7.40833 10.3758 7.55 10.3758C7.69167 10.3758 7.80833 10.4216 7.9 10.5133L8.975 11.5883L11.45 9.11328C11.5417 9.02161 11.6583 8.97578 11.8 8.97578C11.9417 8.97578 12.0583 9.02161 12.15 9.11328C12.2417 9.20495 12.2875 9.32161 12.2875 9.46328C12.2875 9.60495 12.2417 9.72161 12.15 9.81328L9.325 12.6383C9.275 12.6883 9.22083 12.7238 9.1625 12.7448C9.10417 12.7654 9.04167 12.7758 8.975 12.7758Z",
    fill: "#E87A46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#E87A46"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixedPrice);
export default __webpack_public_path__ + "static/media/FixedPrice.58eb2686fd56282c815d7d103d1f482a.svg";
export { ForwardRef as ReactComponent };